import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import ActionButtons from '../../../components/ParametersPage/ActionButtons';
import { DownloadMode } from '../../DownloadManager/reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		downloadManager,
		galleryInfos: {
			config: {
				importantAssets: {
					enabled: importantAssetsEnabled,
				} = { enabled: false },
			},
		},
	} = state;
	const { items } = downloadManager;
	const downloadsIds = Object.keys(items);

	let hasDownloadedItems = false;
	downloadsIds.forEach(key => {
		const item = items[key];

		if (!hasDownloadedItems && item.mode !== DownloadMode.Required) {
			hasDownloadedItems = true;
		}
	});

	return {
		hasDownloadedItems,
		importantAssetsEnabled,
	};
};

export default connect(mapStateToProps)(ActionButtons);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/ActionButtons/index.tsx